var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0057 9.30503H9.37333L9.14918 9.08891C9.93363 8.17639 10.406 6.99171 10.406 5.70297C10.406 2.82933 8.07662 0.5 5.20298 0.5C2.32933 0.5 0 2.82933 0 5.70297C0 8.57662 2.32933 10.9059 5.20298 10.9059C6.49171 10.9059 7.67637 10.4337 8.5889 9.64923L8.80504 9.87336V10.5057L12.8073 14.5L14 13.3073L10.0057 9.30503ZM5.20298 9.30503C3.20984 9.30503 1.60092 7.69611 1.60092 5.70297C1.60092 3.70983 3.20984 2.10091 5.20298 2.10091C7.19612 2.10091 8.80504 3.70983 8.80504 5.70297C8.80504 7.69611 7.19612 9.30503 5.20298 9.30503Z",
    fill: "#00B4D2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.cdc11db5954f9b7ab3d0a2c3e8d2b32e.svg";
export { ForwardRef as ReactComponent };